/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".callout_bbc19fc7 .ms-Suggestions-itemButton{padding:0;border:none}.callout_bbc19fc7 .ms-Suggestions{min-width:300px}"}]);
export const callout = "callout_bbc19fc7";